import { render, staticRenderFns } from "./SupplierManualPurchasingPriceArtikelFiltersComponent.vue?vue&type=template&id=49f56374&"
import script from "./SupplierManualPurchasingPriceArtikelFiltersComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierManualPurchasingPriceArtikelFiltersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports